import React, {useState} from "react"
import "./UserRegistration.css"
import {updateResource} from "../service/http-service";

export const RegistrationInfo = ({userInfo, setUserInfo, page, setPage}) => {

    const [requiredUsername, setRequiredUsername] = useState("");
    const [requiredPassword, setRequiredPassword] = useState("");
    const [matchingPasswords, setMatchingPasswords] = useState("");
    const [requiredEmail, setRequiredEmail] = useState("");
    const [invalidUsernameOrPassword, setInvalidUsernameOrPassword] = useState("");
    const [backError, setBackError] = useState('');

    const [viewNewPass, setViewNewPass] = useState(true)
    const [viewConfirmedPass, setViewConfirmedPass] = useState(true)

    const checkRequiredFields = () => {
        if(userInfo.userName === ""){
            setRequiredUsername("Ве молиме внесете корисничко име");
        }else if (userInfo.password === ""){
            setRequiredUsername("")
            setRequiredPassword("Ве молиме внесете лозинка")
        }else if (userInfo.password !== userInfo.confirmPassword){
            setRequiredUsername("")
            setRequiredPassword("")
            setMatchingPasswords("Лозинките не се исти")
        }else if(userInfo.email === ""){
            setRequiredUsername("")
            setRequiredPassword("")
            setMatchingPasswords("")
            setRequiredEmail("Ве молиме внесете маил")
        }else {
            setRequiredUsername("")
            setRequiredPassword("")
            setMatchingPasswords("")
            setRequiredEmail("")
            updateResource('candidates/create_new_candidate', userInfo)
                .then((data) => {
                    console.log(data.data)
                    sessionStorage.setItem('candidate', JSON.stringify(data.data))
                    sessionStorage.setItem('confirmMessage', 'Пратен е меил за потврда на регистрација')
                    window.location.replace("/career_opportunities/login")
                }).catch((exception) => {
                setBackError(exception.response.data.message);
            })
        }
    }
    return (
           <div className="basic-info mt-3">
              <div className="d-flex flex-column w-100">
                  <input type="text" placeholder="*Корисничко име"
                         value={userInfo.userName}
                         onChange={(e) => setUserInfo({...userInfo, userName: e.target.value})}
                  />
                  {requiredUsername && <small>{requiredUsername}</small>}
              </div>
               <div className="d-flex flex-column w-100">
                 <div className="pass-inputs">
                     <input  type={viewNewPass ? "password" : "text"} placeholder="*Лозинка"  id="pass"
                             value={userInfo.password}
                             onChange={(e) => setUserInfo({...userInfo, password: e.target.value})}
                     />
                     <i onClick={()=> setViewNewPass(!viewNewPass)}
                        className={viewNewPass ? "fa fa-eye text-white" : "fa fa-eye-slash text-white" }/>
                 </div>
                   {requiredPassword && <small>{requiredPassword}</small>}
               </div>
              <div className="d-flex flex-column w-100">
               <div className="pass-inputs">
                   <input  type={viewConfirmedPass ? "password" : "text"} placeholder="*Потврди лозинка"
                             value={userInfo.confirmPassword}
                             onChange={(e) => setUserInfo({...userInfo, confirmPassword: e.target.value})}/>
                   <i  onClick={()=> setViewConfirmedPass(!viewConfirmedPass)}
                       className={viewConfirmedPass ? "fa fa-eye text-white" : "fa fa-eye-slash text-white" }/></div>
                </div>
               <div className="text-center">
                   {matchingPasswords && <small>{matchingPasswords}</small>}
               </div>
               <div className="d-flex flex-column w-100">
                      <input type="email" placeholder="*e-mail адреса"
                      value={userInfo.email}
                             onChange={(e) => setUserInfo({...userInfo, email: e.target.value})}
                          />
                     {requiredEmail && <small>{requiredEmail}</small>}
                 </div>

               {invalidUsernameOrPassword && <small>{invalidUsernameOrPassword}</small>}
              <div className="text-center">{backError && <small>{backError}</small>}</div>
                <div className="form-footer d-flex justify-content-between">
                    <button onClick={()=> setPage(2)}>Претходна</button>
                    <button type='button'
                        onClick={(e)=> {
                            checkRequiredFields();
                        }}
                    >Потврди</button>
                </div>
           </div>
    )
}